module.exports = __webpack_public_path__ + "static/media/SF_nn_primaerlogo_oslo_viken_neg.d7bc25cc.png";